import { hasFieldId } from './conditional-fields-provider/hiddenFieldIds';

type RequiredConfigRow = {
  FieldId: string;
  Required?: boolean | null;
};

/**
 * Configured required state for one field; `undefined` when no row matches, so
 * the caller falls back to the code default. Shared by the label postfix and the
 * validation schema so the two cannot disagree (CUS-374).
 *
 * Matching is case-insensitive because a row's `FieldId` casing is a per-entity
 * convention that need not match the react-hook-form field name (RSP-6818).
 * `hiddenFields` is passed by validation only: CUS-276 relaxed *enforcement* on
 * condition-hidden fields, not their configuration.
 */
export const resolveConfiguredRequired = (
  fieldConfig: RequiredConfigRow[],
  fieldId: string,
  hiddenFields?: Set<string>
): boolean | undefined => {
  const lower = fieldId.toLowerCase();
  const row = fieldConfig.find(
    (candidate) => (candidate.FieldId ?? '').toLowerCase() === lower
  );

  if (!row) {
    return undefined;
  }

  return (
    !!row.Required &&
    !(hiddenFields ? hasFieldId(hiddenFields, row.FieldId) : false)
  );
};
